module.exports = __webpack_public_path__ + "media/images/categories/carousel/business-innovation-b56570c7a29956c40893248d1c08118f.jpg";